import React, { useEffect, useState } from "react";
import { useAuth } from "../../../firebase/AuthProvider";
import { Link, useNavigate } from "react-router-dom";
import TemplateFile from "../../../interfaces/task/TaskFiles/TemplateFile";
import { getTemplateFiles } from "../../../services/fileServices/FileService";
import EditTemplateFile from "./EditTemplateFile";
import { Button } from "react-bootstrap";
import editicons from '../../../assets/images/editicons.svg';
import backarrowbtn from '../../../assets/images/backarrowbtn.svg';
import './templatefiles.css'

const EditTemplateFiles = () => {
  const { currentUser, currentRoles } = useAuth();
  const navigate = useNavigate();

  const [templates, setTemplates] = useState<TemplateFile[]>([]);
  const [selectedTemplate, setSelectedTemplate] = useState<TemplateFile>();
  const [reload, setReload] = useState<boolean>(false);

  useEffect(() => {
    const fetchTemplates = async () => {
      if (currentUser !== null) {
        const authToken = await currentUser.getIdToken();
        const response = await getTemplateFiles(authToken);
        if (response) {
          setTemplates(response);
        }
      }
    };

    fetchTemplates();
  }, [currentUser, reload]);

  const selectTemplate = (template: TemplateFile) => {
    if (!template) {
      setReload(!reload);
    }
    setSelectedTemplate(template);
  };

    const backBtnUrl = (): string => {
        if (currentRoles?.some((role) => role.name === "OWNER" || role.name === "ADMIN")) {
            return "/dashboard/owner/settings";
        } else {
            return "/settings";
        }
    }

    console.log('templates: ', templates)
  return (
    <>
      <div className="">

        <div className="">
          {selectedTemplate ? (
            <div className="new_activity_container">
              <EditTemplateFile
                template={selectedTemplate}
                setSelectedTemplate={setSelectedTemplate}
                onSaveSuccess={() => setReload(prev => !prev)}
              />
            </div>
          ) : (
            <div className="common_card">
              <div className="top top_bar_flx border_tittle">
                <div className="top_bar_tittle">
                  <h2>
                    <Link to={backBtnUrl()}><img style={{ width: '1.5rem' }} src={backarrowbtn} alt="" /></Link>
                    Template Files
                    </h2>
                </div>
                <div className="top_right_flx">
                  <Button className="btn_sm" onClick={() => navigate("/file/new/template/")}>Add New</Button>
                </div>
              </div>
              <div className="task_activity_options_grid mby_24">
                {templates &&
                  templates.map((template, index) => (
                    <div key={index} className="task_activity_options_card template_file_card">
                      <div className="task_activity_options_card_txt">
                        <h3>{template.fileName}</h3>
                      </div>
                      <button className="shrink-0" onClick={() => selectTemplate(template)}>
                        <img style={{ width: '1.5rem' }} src={editicons} alt="editicons" />
                      </button>
                    </div>
                  ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default EditTemplateFiles;
